import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import FigureLibrary from "@/pages/figures/page";
import FigureDetail from "@/pages/figure-detail/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/renwu",
    element: <FigureLibrary />,
  },
  {
    path: "/renwu/:id",
    element: <FigureDetail />,
  },
  {
    path: "/guanyu",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;